
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650248956473",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "13634",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M555.008 837.248v66.304h180.736V1024h-481.92v-120.448H434.56v-66.304c-204.8-30.08-361.408-204.8-361.408-415.616C73.152 210.816 229.76 36.16 434.56 6.016V0h120.448v6.016c204.8 30.08 361.408 204.8 361.408 415.616 0 210.816-156.608 385.536-361.408 415.616z m-60.16-114.432c168.576 0 301.12-132.48 301.12-301.184 0-168.64-132.48-301.184-301.184-301.184-168.64 0-301.184 132.48-301.184 301.184 0 168.704 132.48 301.184 301.184 301.184z m0-180.672a120.832 120.832 0 0 1-120.512-120.512c0-66.24 54.208-120.448 120.448-120.448s120.448 54.208 120.448 120.448a120.832 120.832 0 0 1-120.448 120.512z",
        "p-id": "13635"
      }
    }
  ]
})
    }
  